// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonButton, IonCol, IonRow, IonText, IonToolbar } from "@ionic/react"
import { SectionModal } from "./SectionModal"
import { useLocales } from "react-localized"
import { useSectionDimensions } from "./useSectionDimensions"
import { ScreenSizeConditional } from "./ScreenSizeConditional"
import { DocumentationComponent } from "./DocumentationComponent"


interface ServiceNotAvailableModalProps {
  isOpen: boolean
  children?: React.ReactNode
  close: () => void
}


const ServiceNotAvailableModal: React.FC<ServiceNotAvailableModalProps> = ({
  close,
  isOpen
}) => {
  const {gettext} = useLocales()
  return (
    <SectionModal grid isOpen={isOpen}>
      <IonRow className="main" style={{height: "100%"}}>
        <IonCol>
          <DocumentationComponent name="error/503"/>
          <IonButton className="navigation" fill="clear" onClick={() => close()}>
            {gettext("Close this message")}
          </IonButton>
        </IonCol>
      </IonRow>
      <IonButton
        fill="clear"
        onClick={close}
        style={{margin: "0 auto", width: "100%"}}
      >
        {gettext("Close this message")}
      </IonButton>
    </SectionModal>
  )
}
  
  export { ServiceNotAvailableModal }